import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Initial check
    checkMobile();

    // Add listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export function useIsLowPerformance(): boolean {
  const [isLowPerf, setIsLowPerf] = useState(false);

  useEffect(() => {
    // Check for low-end device indicators
    const checkPerformance = () => {
      // Check hardware concurrency (CPU cores)
      const cores = navigator.hardwareConcurrency || 4;
      
      // Check device memory if available
      const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory || 8;
      
      // Consider low performance if few cores or low memory
      setIsLowPerf(cores <= 2 || memory <= 2);
    };

    checkPerformance();
  }, []);

  return isLowPerf;
}

